var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReviewsWave(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 414 80",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414 0H0v62.472S23.7 47 104.718 47c34.731 1.451 64.968 9.224 94.679 16.86C231.093 72.007 262.189 80 297.5 80 360 80 414 62.472 414 62.472V0z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsWave);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MTQgODAiPgogIDxwYXRoIGQ9Ik00MTQgMEgwdjYyLjQ3MjJTMjMuNzAwNyA0NyAxMDQuNzE4IDQ3YzM0LjczMSAxLjQ1MTQgNjQuOTY4IDkuMjIzNiA5NC42NzkgMTYuODYwNEMyMzEuMDkzIDcyLjAwNzMgMjYyLjE4OSA4MCAyOTcuNSA4MCAzNjAgODAgNDE0IDYyLjQ3MjIgNDE0IDYyLjQ3MjJWMFoiIGZpbGw9IiNmZmYiLz4KPC9zdmc+";
export { ForwardRef as ReactComponent };